module.exports = __webpack_public_path__ + "media/不锈钢vr.f0f72175.mp3";